// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bar-graph_wrapper__2RRZD","titleAndBulletsWrapper":"bar-graph_titleAndBulletsWrapper__It73L","title":"bar-graph_title__3cd7h","bullets":"bar-graph_bullets__3azQ5"};